import { ArrowBackIcon, ArrowForwardIcon } from '@/components/icons'
import { Autoplay, Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.min.css'

const sliderData = [
  {
    alt: 'DUPR Dashboard',
    src: '/img/sliders/1-dashboard.png',
  },
  {
    alt: 'Browse Players',
    src: '/img/sliders/2-browse-players.png',
  },
  {
    alt: 'Match History',
    src: '/img/sliders/3-match-history.png',
  },
]

export const ExploreTechnology = () => {
  return (
    <div className="bg-gradient-to-r from-iceBlue to-paleBlue">
      <div className="container mx-auto px-4 md:px-10 py-8 md:py-20">
        <div className="flex flex-col gap-y-3 md:gap-y-6 items-center">
          <p className="text-azul text-xl font-semibold mb-0 text-center">Explore Our Technology</p>
          <p className="text-navyBlue text-5xl leading-tight font-semibold mb-0 text-center">Pickleball Reinvented</p>
          <div className="w-full">
            <div className="lg:mx-10 relative">
              <Swiper
                className="sm:px-5"
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={50}
                slidesPerView={1}
                navigation={{
                  nextEl: '.swiper-nav-control  .swiper-button-next',
                  prevEl: '.swiper-nav-control .swiper-button-prev',
                }}
                loop
                pagination={{ clickable: true }}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
              >
                {sliderData.map((slider, id) => (
                  <SwiperSlide key={`${id + 1}`}>
                    <img src={slider.src} alt={slider.alt} />
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="swiper-nav-control">
                <ArrowBackIcon className="hidden sm:block -left-8 swiper-button-prev p-1 h-10 w-auto border border-azul hover:bg-lightBlue hover:text-azul text-azul" />
                <ArrowForwardIcon className="hidden sm:block -right-8 swiper-button-next p-1 h-10 w-auto border border-azul hover:bg-lightBlue hover:text-azul text-azul" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
